export default "__VITE_ASSET__BYbuFyPL__"